import HeaderForBusiness from './HeaderForBusiness';

export default HeaderForBusiness;